export const ShareEventMarket = {
    HK: '1',
    SG: '2',
    MY: '3',
    US: '4',
    JP: '5',
    CA: '6',
    AU: '7'
};

export const ShareEventMarketOption = Object.entries(ShareEventMarket).map(([key, value]) => ({
    value,
    label: key
}));

export const FORBIDDEN_TYPE = {
    NOT_APP: 'notApp',
    LOW_VERSION: 'lowVersion'
};

export const UPGRADE_LINK = {
    NN: 'https://www.futunn.com/download/one-link',
    MOOMOO: 'https://moomoo.onelink.me/TGEw/2cz9vnr4'
};

export const BEHAVIOR_EVENT = {
    SHARE_SUCCESS: 'share_success' // 分享成功
};

export const BASE_APP_VERSION = '14.29.17107';

// 24.11.14 IOS下facebook分享组件版本号
export const IOS_FACEBOOK_IMAGE_DIRECT_VERSION = '14.41.18308';

// 24.11.27 今日盈亏图分享图组件版本号
export const FETCH_PROFIT_IMAGE_VERSION = '14.45.18707';

// 图片类型
export const IMAGE_TYPE = {
    STATIC: 'static', // 静态图
    MONEY_IP: 'money_IP', // 盈亏金额-IP图
    MONEY_LOGO: 'money_logo', // 盈亏金额-logo图
    RATIO_IP: 'ratio_IP', // 盈亏比例-IP图
    RATIO_LOGO: 'ratio_logo' // 盈亏比例-logo图
};

// 暴露到fego的方法
export const EXPOSE_FEGO_METHOD = {
    SHOW_REDDIT_SHARE: 'showRedditShare', // 唤起Reddit分享
    SHOW_FACEBOOK_SHARE: 'showFacebookShare', // 唤起Facebook分享
    SHOW_TELEGRAM_SHARE: 'showTelegramShare', // 唤起Telegram分享
    SHOW_XIAOHONGSHU_SHARE: 'showXiaohongshuShare', // 唤起小红书分享
    SHOW_TWITTER_SHARE: 'showTwitterShare', // 唤起Twitter分享
    SHOW_INSTAGRAM_SHARE: 'showInstagramShare', // 唤起Instagram分享
    SHOW_WECHAT_SHARE: 'showWechatShare', // 唤起微信分享
    SHOW_WECHAT_MOMENTS_SHARE: 'showWechatMomentsShare' // 唤起微信朋友圈分享
};

// 分享类型
export const SHARE_TYPE = {
    HORIZONTAL_TAB: 'horizontalTab',
    BOTTOM_SHARE_BTN: 'bottomShareBtn'
};
